var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _g2, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 555 94.24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(.70710678 .70710678 -.70710678 .70710678 38.27 -15.89)",
    gradientUnits: "userSpaceOnUse",
    x1: 10.34,
    x2: 66.3,
    y1: 38.25,
    y2: 38.25
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 61.44,
    x2: 64.58,
    xlinkHref: "#a",
    y1: 25.45,
    y2: 25.45
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 49.44,
    x2: 66.33,
    xlinkHref: "#a",
    y1: 20.43,
    y2: 20.43
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 10.34,
    x2: 27.24,
    xlinkHref: "#a",
    y1: 56.12,
    y2: 56.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000f66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m127.11 59.56-21.32-28v28h-9.57v-44h8.94l20.63 27.12v-27.16h9.56v44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.92 59.56v-44h33.16v8.62h-23.59v8.93h20.76v8.62h-20.76v9.25h23.9v8.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.85 59.56-4-9.88h-18.65l-4 9.88h-9.9l18.87-44.35h8.94l18.89 44.35zm-13.33-32.71-5.86 14.28h11.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.51 59.56-9.43-14.09h-7.62v14.09h-9.68v-44h20.13q7.86 0 12.23 3.84t4.38 10.7v.12a13.79 13.79 0 0 1 -2.61 8.71 15 15 0 0 1 -6.83 4.94l10.76 15.73zm.19-29a5.62 5.62 0 0 0 -2-4.72 8.88 8.88 0 0 0 -5.6-1.57h-9.63v12.64h9.82a8 8 0 0 0 5.5-1.7 5.74 5.74 0 0 0 1.92-4.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.74 59.56v-28.75l-12.4 18.81h-.25l-12.27-18.62v28.56h-9.56v-44h10.45l11.57 18.62 11.58-18.62h10.44v44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381 46.38a22.51 22.51 0 0 1 -12.3 12.14 24.2 24.2 0 0 1 -9.41 1.8 23.89 23.89 0 0 1 -9.37-1.8 23.27 23.27 0 0 1 -7.4-4.84 21.83 21.83 0 0 1 -4.84-7.17 22.69 22.69 0 0 1 -1.73-8.84v-.13a22.36 22.36 0 0 1 1.76-8.84 22.59 22.59 0 0 1 12.29-12.14 25.52 25.52 0 0 1 18.78 0 23.39 23.39 0 0 1 7.39 4.84 21.79 21.79 0 0 1 4.83 7.18 22.62 22.62 0 0 1 1.73 8.84v.12a22.32 22.32 0 0 1 -1.73 8.84zm-8.37-8.84a14.69 14.69 0 0 0 -1-5.35 13.24 13.24 0 0 0 -7-7.39 13 13 0 0 0 -5.35-1.1 13.25 13.25 0 0 0 -5.38 1.07 12.25 12.25 0 0 0 -4.15 3 14 14 0 0 0 -2.75 4.33 14.44 14.44 0 0 0 -1 5.32v.12a14.68 14.68 0 0 0 1 5.35 13.3 13.3 0 0 0 7 7.39 12.72 12.72 0 0 0 5.38 1.1 13.06 13.06 0 0 0 5.34-1.07 12.33 12.33 0 0 0 4.19-3 14 14 0 0 0 2.7-4.38 14.36 14.36 0 0 0 1-5.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.29 24.46v35.1h-9.69v-35.1h-13.4v-8.94h36.49v8.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.55 59.56v-44h9.69v44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.35 46.38a22.88 22.88 0 0 1 -4.88 7.24 22.64 22.64 0 0 1 -7.42 4.9 24.2 24.2 0 0 1 -9.41 1.8 23.89 23.89 0 0 1 -9.37-1.8 23.22 23.22 0 0 1 -7.39-4.84 21.7 21.7 0 0 1 -4.88-7.17 22.69 22.69 0 0 1 -1.73-8.84v-.13a22.36 22.36 0 0 1 1.76-8.84 22.59 22.59 0 0 1 12.3-12.14 24.34 24.34 0 0 1 9.41-1.79 24.07 24.07 0 0 1 9.37 1.79 23.39 23.39 0 0 1 7.39 4.84 21.79 21.79 0 0 1 4.85 7.18 22.62 22.62 0 0 1 1.73 8.84v.12a22.32 22.32 0 0 1 -1.73 8.84zm-8.35-8.84a14.69 14.69 0 0 0 -1-5.35 13.16 13.16 0 0 0 -7-7.39 13 13 0 0 0 -5.35-1.1 13.25 13.25 0 0 0 -5.38 1.07 12.25 12.25 0 0 0 -4.15 3 14 14 0 0 0 -2.7 4.37 14.25 14.25 0 0 0 -1 5.32v.12a14.48 14.48 0 0 0 1 5.35 13.24 13.24 0 0 0 7 7.39 12.75 12.75 0 0 0 5.38 1.1 13.14 13.14 0 0 0 5.35-1.07 12.29 12.29 0 0 0 4.18-3 14 14 0 0 0 2.67-4.35 14.36 14.36 0 0 0 1-5.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m537.62 59.56-21.33-28v28h-9.56v-44h8.93l20.64 27.08v-27.12h9.56v44z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Gotham-Medium, Gotham",
    fontSize: 19.34,
    fontWeight: 500,
    transform: "translate(324.99 90.96)"
  }, "INTER", /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.04em",
    x: 60.87,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "0em",
    x: 75.31,
    y: 0
  }, "CTIVE VENUES")), /*#__PURE__*/React.createElement("rect", {
    height: 76.58,
    rx: 11.53,
    width: 76.58
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64.58 23.83-3.14 3.14",
    fill: "#1883ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m66.33 18.51a8.45 8.45 0 0 1 -.48 3 8.54 8.54 0 0 1 -.85 1.7s-.2.31-.43.62c-.6.78-3.16 3.34-6.69 6.69a85 85 0 0 1 -6.7-6.7 9.68 9.68 0 0 1 -.84-1.34 8.13 8.13 0 0 1 -.42-1 9.46 9.46 0 0 1 -.49-2.83 8.45 8.45 0 0 1 16.89-.16z",
    fill: "#1883ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m64.58 23.83-3.14 3.14",
    fill: "#1883ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10.34 57.77a8.58 8.58 0 0 1 .49-2.83 8.84 8.84 0 0 1 .84-1.71s.19-.31.43-.62c.6-.77 3.15-3.34 6.69-6.69a86.88 86.88 0 0 1 6.7 6.7 9.68 9.68 0 0 1 .84 1.38 8.13 8.13 0 0 1 .42 1 9.46 9.46 0 0 1 .49 2.83 8.45 8.45 0 0 1 -16.9 0z",
    fill: "#f2a33a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m27.25 17.59v4.44",
    fill: "#fefefe"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m24.85 12.7a8.7 8.7 0 0 1 1.66 2.3 9.28 9.28 0 0 1 .62 1.81s.07.35.12.74c.13 1 .14 4.59 0 9.46a84.2 84.2 0 0 1 -9.46 0 10.82 10.82 0 0 1 -1.55-.35 8.31 8.31 0 0 1 -1-.4 9.51 9.51 0 0 1 -2.34-1.65 8.45 8.45 0 1 1 11.95-11.91z",
    fill: "#fefefe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m27.25 17.59v4.44",
    fill: "#fefefe"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m49.51 58.85v-4.43",
    fill: "#32d7ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m51.92 63.74a8.14 8.14 0 0 1 -1.66-2.34 9 9 0 0 1 -.62-1.8s-.08-.36-.13-.75c-.13-1-.13-4.59 0-9.46a87.06 87.06 0 0 1 9.47 0 10.08 10.08 0 0 1 1.55.36 9.32 9.32 0 0 1 1 .39 9.59 9.59 0 0 1 2.34 1.66 8.44 8.44 0 0 1 -11.95 11.94z",
    fill: "#32d7ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m49.51 58.85v-4.43",
    fill: "#32d7ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    height: 72.12,
    opacity: 0.8,
    rx: 8.43,
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -15.83 38.3)",
    width: 16.89,
    x: 29.88,
    y: 2.19
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.58 23.88-3.14 3.14",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.33 18.57a8.45 8.45 0 0 1 -.48 3 8.84 8.84 0 0 1 -.85 1.7s-.2.31-.43.61c-.6.78-3.16 3.34-6.69 6.69a85.63 85.63 0 0 1 -6.7-6.69 10.12 10.12 0 0 1 -.84-1.35 7.46 7.46 0 0 1 -.42-1 9.54 9.54 0 0 1 -.49-2.83 8.45 8.45 0 0 1 16.89-.16z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.58 23.88-3.14 3.14",
    fill: "url(#b)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m10.34 57.82a8.58 8.58 0 0 1 .49-2.82 8.84 8.84 0 0 1 .84-1.71s.19-.31.43-.62c.6-.77 3.15-3.33 6.69-6.68a85.63 85.63 0 0 1 6.7 6.69 10.4 10.4 0 0 1 .84 1.32 8.13 8.13 0 0 1 .42 1 9.54 9.54 0 0 1 .49 2.83 8.45 8.45 0 0 1 -16.9 0z",
    fill: "url(#d)",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo17);
export default __webpack_public_path__ + "static/media/logo17.8962182a.svg";
export { ForwardRef as ReactComponent };